module.exports = __webpack_public_path__ + "img/Dai5-new-re.8722d930.png";